import $ from "jquery";

export default function () {
    $(document).on('select2:open', () => {
        document.querySelector('.select2-container--open .select2-search__field').focus();
    });

    function initSelect2(element) {
        element.select2({
            theme: 'bootstrap4',
            width: element.data('width') ? element.data('width') : element.hasClass('w-100') ? '100%' : 'style',
            placeholder: element.data('placeholder'),
            allowClear: Boolean(element.data('allow-clear'))
        })
    }

    $('.js-select2').each(function () {
        initSelect2($(this));
    });

    $(".js-select-two-tag").select2({
        tags: true,
        tokenSeparators: ['|', '|'],
        theme: 'bootstrap4',
        width: $(this).data('width') ? $(this).data('width') : $(this).hasClass('w-100') ? '100%' : 'style',
        placeholder: $(this).data('placeholder'),
        allowClear: Boolean($(this).data('allow-clear')),
        closeOnSelect: !$(this).attr('multiple'),
        language:{
            noResults : function () { return ''; }
        }
    });
}
